import {
  Event,
  ConstructorArgs as EventConstructorArgs,
} from "../../core/Event";
import { EventCategories } from "../../event-categories";
import { EventSubCategories } from "../../event-sub-categories";

export type Data = {
  provider: `phone_number` | `email`;
  credential: string;
  errorMessage?: string | null | undefined;
};

export type ConstructorArgs = Data & Partial<EventConstructorArgs>;

class OtpVerifyFailed extends Event<Data> {
  public constructor(args: ConstructorArgs) {
    const { provider, credential, errorMessage, ...baseArgs } = args;

    super({
      ...baseArgs,
      category: EventCategories.UI,
      subCategory: EventSubCategories.AUTH,
      type: `OTP_VERIFY_FAILED`,
      data: {
        provider,
        credential,
        errorMessage,
      },
    });
  }
}

export { OtpVerifyFailed };
